import { EventEmitter, TemplateRef } from "@angular/core";
import { Session } from '../../../../shared/model/session.model';
import { debug } from '../../../../app.constants';
import moment from "moment/moment";
import { MessageService } from '../../../message/message.service';
import { JhiAlertService } from '../../../../ng-jhipster/service';
import { SessionStorageService } from "ngx-webstorage";
import { SessionService } from '../../../session/session.service';
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { AccountService } from '../../../../core/auth/account.service';
import { CoachDetailsService } from '../../../slot/coach-details.service';
import { SessionEndsInXMinuteComponent } from '../../../session/session-chat-coach/session-control.component/session-ends-in-x-minute/session-ends-in-x-minute.component';
import { TrackerService } from '../../../../core/tracker/tracker.service';
import { SessionIsAboutToEndComponent } from '../../../session/session-chat-coach/session-control.component/session-is-about-to-end/session-is-about-to-end.component';
import * as i0 from "@angular/core";
import * as i1 from "../../../message/message.service";
import * as i2 from "../../../../ng-jhipster/service";
import * as i3 from "ngx-webstorage";
import * as i4 from "../../../session/session.service";
import * as i5 from "@ng-bootstrap/ng-bootstrap";
import * as i6 from "@ngx-translate/core";
import * as i7 from "../../../../core/auth/account.service";
import * as i8 from "../../../slot/coach-details.service";
import * as i9 from "../../../../core/tracker/tracker.service";
import * as i10 from "../../../../ng-jhipster/language/jhi-translate.directive";
import * as i11 from "@angular/common";
import * as i12 from "../../session-chat-user/session-control-dropdown/session-control-dropdown.component";
import * as i13 from "../../session-chat-user/video-call-dropdown/video-call-dropdown.component";
import * as i14 from "../../../video-call/in-progress-video-call-indicator/in-progress-video-call-indicator.component";
import * as i15 from "@fortawesome/angular-fontawesome";
const _c0 = function (a0) { return { login: a0 }; };
function SessionControlComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "span", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c0, ctx_r0.session.user.login));
} }
const _c1 = function (a0) { return { daysLeft: a0 }; };
function SessionControlComponent_div_10_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "span", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c1, ctx_r12.getDays()));
} }
function SessionControlComponent_div_10_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "span", 21);
    i0.ɵɵelementEnd();
} }
function SessionControlComponent_div_10_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, SessionControlComponent_div_10_div_1_div_1_Template, 2, 3, "div", 18);
    i0.ɵɵtemplate(2, SessionControlComponent_div_10_div_1_div_2_Template, 2, 0, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.session.minutesLeftToSessionStart >= 24 * 60 * 2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.session.minutesLeftToSessionStart < 24 * 60 * 2);
} }
const _c2 = function (a0) { return { hoursLeft: a0 }; };
function SessionControlComponent_div_10_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "span", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c2, ctx_r14.getHours()));
} }
function SessionControlComponent_div_10_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "span", 23);
    i0.ɵɵelementEnd();
} }
function SessionControlComponent_div_10_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, SessionControlComponent_div_10_div_2_div_1_Template, 2, 3, "div", 18);
    i0.ɵɵtemplate(2, SessionControlComponent_div_10_div_2_div_2_Template, 2, 0, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.session.minutesLeftToSessionStart >= 60 * 2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.session.minutesLeftToSessionStart < 60 * 2);
} }
const _c3 = function (a0) { return { minutesLeft: a0 }; };
function SessionControlComponent_div_10_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "span", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c3, ctx_r11.minutesLeft - ctx_r11.session.duration));
} }
function SessionControlComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, SessionControlComponent_div_10_div_1_Template, 3, 2, "div", 18);
    i0.ɵɵtemplate(2, SessionControlComponent_div_10_div_2_Template, 3, 2, "div", 18);
    i0.ɵɵtemplate(3, SessionControlComponent_div_10_div_3_Template, 2, 3, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.session.minutesLeftToSessionStart >= 24 * 60);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.session.minutesLeftToSessionStart >= 60 && ctx_r1.session.minutesLeftToSessionStart < 24 * 60);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.session.minutesLeftToSessionStart > 10 && ctx_r1.session.minutesLeftToSessionStart < 60);
} }
function SessionControlComponent_div_11_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "span", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c3, ctx_r16.minutesLeft - ctx_r16.session.duration));
} }
function SessionControlComponent_div_11_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "span", 25);
    i0.ɵɵelementEnd();
} }
function SessionControlComponent_div_11_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "span", 26);
    i0.ɵɵelement(2, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c3, ctx_r18.minutesLeft));
} }
function SessionControlComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, SessionControlComponent_div_11_div_1_Template, 2, 3, "div", 18);
    i0.ɵɵtemplate(2, SessionControlComponent_div_11_div_2_Template, 2, 0, "div", 18);
    i0.ɵɵtemplate(3, SessionControlComponent_div_11_div_3_Template, 3, 3, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.session.minutesLeftToSessionStart > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.session.minutesLeftToSessionStart === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.session.minutesLeftToSessionStart <= 0);
} }
function SessionControlComponent_div_12_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 30);
    i0.ɵɵlistener("click", function SessionControlComponent_div_12_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(2); return ctx_r20.extendSessionByTenMinutes(); });
    i0.ɵɵelement(1, "span", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("background", ctx_r19.minutesLeft > 10 || ctx_r19.session.ended ? "#7CBFAE" : "#44A38B");
} }
function SessionControlComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, SessionControlComponent_div_12_button_1_Template, 2, 2, "button", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.session.minutesLeftToSessionStart <= 0);
} }
function SessionControlComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "button", 32);
    i0.ɵɵlistener("click", function SessionControlComponent_div_13_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(); const _r7 = i0.ɵɵreference(19); return ctx_r22.open(_r7); });
    i0.ɵɵelement(2, "span", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r4.session.ended);
} }
function SessionControlComponent_div_14_video_call_dropdown_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "video-call-dropdown", 36);
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("session", ctx_r24.session)("coachDetails", ctx_r24.coachDetails);
} }
function SessionControlComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵtemplate(1, SessionControlComponent_div_14_video_call_dropdown_1_Template, 1, 2, "video-call-dropdown", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r5.isVideoCallInProgress);
} }
function SessionControlComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelementStart(1, "in-progress-video-call-indicator", 38);
    i0.ɵɵlistener("videoCallIsInProgress", function SessionControlComponent_div_17_Template_in_progress_video_call_indicator_videoCallIsInProgress_1_listener($event) { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.isVideoCallInProgress = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("d-none", !ctx_r6.isVideoCallInProgress);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("session", ctx_r6.session);
} }
function SessionControlComponent_ng_template_18_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵelementStart(1, "div", 41);
    i0.ɵɵelementStart(2, "fa-icon", 42);
    i0.ɵɵlistener("click", function SessionControlComponent_ng_template_18_div_0_Template_fa_icon_click_2_listener() { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(2); return ctx_r29.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 43);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelement(5, "h3", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelement(7, "p", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 46);
    i0.ɵɵelementStart(9, "button", 47);
    i0.ɵɵlistener("click", function SessionControlComponent_ng_template_18_div_0_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r30); const ctx_r31 = i0.ɵɵnextContext(2); return ctx_r31.endSession(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 48);
    i0.ɵɵlistener("click", function SessionControlComponent_ng_template_18_div_0_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r30); const ctx_r32 = i0.ɵɵnextContext(2); return ctx_r32.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function SessionControlComponent_ng_template_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SessionControlComponent_ng_template_18_div_0_Template, 11, 0, "div", 39);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r8.ended);
} }
export class SessionControlComponent {
    constructor(messageService, alertService, sessionStorage, sessionService, modalService, translate, accountService, coachDetailsService, trackerService) {
        this.messageService = messageService;
        this.alertService = alertService;
        this.sessionStorage = sessionStorage;
        this.sessionService = sessionService;
        this.modalService = modalService;
        this.translate = translate;
        this.accountService = accountService;
        this.coachDetailsService = coachDetailsService;
        this.trackerService = trackerService;
        this.displayScriptComponent = new EventEmitter();
        this.resourceSelected = new EventEmitter();
        this.minutesLeft = 0;
        this.secondsLeft = 0;
        this.endsIn = 'inukaNgApp.session.yourSessionIsGoingToEnd';
        this.showSessionSummary = false;
        this.secondsLeftDisplayed = false;
    }
    ngOnInit() {
        this.updateMinutesLeftRecurring();
        if (this.accountService.isCoach()) {
            this.coachDetailsService.findCoachDetails(this.session.coachId).subscribe(res => {
                this.coachDetails = res.body;
            });
        }
        this.subscribeToWebsocket();
    }
    subscribeToWebsocket() {
        this.websocketSubscription = this.trackerService.listenerSubject.subscribe(value => {
            var _a;
            const message = value['body'];
            const type = value['type'];
            if (type === 'SESSION_EXTENDED') {
                let s = message;
                if (s.id === ((_a = this.session) === null || _a === void 0 ? void 0 : _a.id)) {
                    this.session = s;
                    this.updateMinutesLeft();
                }
            }
        });
    }
    updateMinutesLeftRecurring() {
        this.updateMinutesLeft();
        if (this.session.ended) {
            return;
        }
        console.log('updateMinutesLeftRecurring, minutes left: ' + this.minutesLeft + ", seconds left: " + this.secondsLeft);
        if (this.minutesLeft === this.session.duration || this.minutesLeft === this.session.duration - 1) {
            this.sessionService.getSession(this.session.id).subscribe((res) => {
                this.session = res.body;
            }, (err) => {
                console.log(err);
            });
        }
        if (this.accountService.isCoach()) {
            if (this.minutesLeft === 10) {
                if (!this.modalService.hasOpenModals()) {
                    const modalRef = this.modalService.open(SessionEndsInXMinuteComponent);
                    modalRef.componentInstance.minutesLeft = 10;
                    modalRef.componentInstance.session = this.session;
                }
                // this.alertService.info('inukaNgApp.session.yourSessionIsGoingToEnd', {param: 10});
            }
            else if (this.minutesLeft === 5) {
                if (!this.modalService.hasOpenModals()) {
                    const modalRef = this.modalService.open(SessionEndsInXMinuteComponent);
                    modalRef.componentInstance.minutesLeft = 5;
                    modalRef.componentInstance.session = this.session;
                }
                // this.alertService.info('inukaNgApp.session.yourSessionIsGoingToEnd', {param: 5});
            }
            else if (this.minutesLeft === 1) {
                if (!this.modalService.hasOpenModals()) {
                    const modalRef = this.modalService.open(SessionIsAboutToEndComponent);
                    modalRef.componentInstance.session = this.session;
                }
            }
            else if (this.minutesLeft === 0) {
                // ignored since this scenario is handled in updateMinutesLeftRecurring() method
            }
        }
        // initialize timer
        if (this.minutesLeft > 0) {
            let nextRepeat = this.secondsLeft % 60 === 0 ? 60 : this.secondsLeft % 60;
            console.log("nextRepeat: " + nextRepeat + " seconds later");
            this.updateMinutesLeftRecurringHandle = setTimeout(() => {
                debug("setTimeout 1: " + this.minutesLeft);
                this.updateMinutesLeftRecurring();
            }, nextRepeat * 1000);
        }
        else {
            console.log('Minutes left timer ended');
            // SESSION_EXTENDED ws message already updates session, this is added just in case.
            if (!this.session.ended)
                this.showSessionSummary = true;
            this.session.minutesLeftToSessionEnd = 0;
            Session.changeStatusOfSessionToEnded(this.session);
        }
    }
    updateMinutesLeft() {
        const sessionEnd = moment(this.session.sessionStartTime).add(this.session.duration, 'minutes');
        const now = moment.now();
        const secondsLeft = sessionEnd.diff(now, 'seconds');
        let partialMinute = secondsLeft % 60 > 0 ? 1 : 0;
        const minutesLeft = sessionEnd.diff(now, 'minutes') + partialMinute;
        this.minutesLeft = minutesLeft > 0 ? minutesLeft : 0;
        this.secondsLeft = secondsLeft > 0 ? secondsLeft : 0;
        // Following code block may be used for debugging purpopses
        // if (this.secondsLeftInterval !== 0) {
        //   clearInterval(this.secondsLeftInterval);
        // }
        //
        // this.secondsLeftInterval = setInterval(() => {
        //   this.secondsLeft--;
        //   console.log("secondsLeft: " + this.secondsLeft);
        // }, 1000);
    }
    getHours() {
        return Math.floor(this.session.minutesLeftToSessionStart / 60);
    }
    getDays() {
        return Math.floor(this.session.minutesLeftToSessionStart / (24 * 60));
    }
    open(content) {
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(result => {
            this.closeResult = `Closed with: ${result}`;
        }, reason => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }
    getDismissReason(reason) {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        }
        else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        }
        else {
            return `with: ${reason}`;
        }
    }
    endSession() {
        this.sessionService.endSession(this.session.id).subscribe(() => {
            this.ended = true;
            this.modalService.dismissAll();
        });
    }
    extendSessionByTenMinutes() {
        this.sessionService.extendSession(this.session.id).subscribe(s => {
            this.session = s;
        });
    }
    openScriptComponent() {
        this.displayScriptComponent.emit();
    }
    dismissAll() {
        this.modalService.dismissAll();
    }
    onResourceSelected($event) {
        this.resourceSelected.emit({ resource: $event.resource });
    }
    ngOnDestroy() {
        var _a;
        if (this.updateMinutesLeftRecurringHandle) {
            clearInterval(this.updateMinutesLeftRecurringHandle);
        }
        (_a = this.websocketSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
}
SessionControlComponent.ɵfac = function SessionControlComponent_Factory(t) { return new (t || SessionControlComponent)(i0.ɵɵdirectiveInject(i1.MessageService), i0.ɵɵdirectiveInject(i2.JhiAlertService), i0.ɵɵdirectiveInject(i3.SessionStorageService), i0.ɵɵdirectiveInject(i4.SessionService), i0.ɵɵdirectiveInject(i5.NgbModal), i0.ɵɵdirectiveInject(i6.TranslateService), i0.ɵɵdirectiveInject(i7.AccountService), i0.ɵɵdirectiveInject(i8.CoachDetailsService), i0.ɵɵdirectiveInject(i9.TrackerService)); };
SessionControlComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SessionControlComponent, selectors: [["session-control"]], inputs: { session: "session" }, outputs: { displayScriptComponent: "displayScriptComponent", resourceSelected: "resourceSelected" }, decls: 20, vars: 8, consts: [[1, "session-chat-header"], [1, "bg-1", "session-control", "d-flex", "justify-content-between", "align-items-center"], [1, "d-xl-none", "ml-2", "script-div"], [1, "btn", "btn-secondary", 3, "click"], [1, "open-book-icon"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#open-book"], ["jhiTranslate", "sessionChat.word.script"], [1, "d-none", "d-xl-block"], [1, "d-flex", "justify-content-between", "align-items-center", "ml-2"], ["class", "d-flex justify-content-between align-items-center", 4, "ngIf"], ["class", "d-none d-xl-block mr-2", 4, "ngIf"], ["class", "d-none d-xl-block ml-2 mr-2 video-icon-div", 4, "ngIf"], [1, "mr-2"], [3, "session", "resourceSelected"], ["class", "px-3 py-2", "style", "background-color: #F8F7F2; position: absolute; width: 100%; z-index: 200;", 3, "d-none", 4, "ngIf"], ["endSessionModal", ""], [1, "d-flex", "justify-content-between", "align-items-center"], ["jhiTranslate", "sessionChat.paragraph.noSession", 1, "time-left", 3, "translateValues"], ["class", "mr-2 text-center", 4, "ngIf"], [1, "mr-2", "text-center"], ["jhiTranslate", "sessionChat.paragraph.willStartInDays", 1, "time-left", 3, "translateValues"], ["jhiTranslate", "sessionChat.paragraph.willStartInADay", 1, "time-left"], ["jhiTranslate", "sessionChat.paragraph.willStartInHours", 1, "time-left", 3, "translateValues"], ["jhiTranslate", "sessionChat.paragraph.willStartInAnHour", 1, "time-left"], ["jhiTranslate", "sessionChat.paragraph.willStartInMinutes", 1, "time-left", 3, "translateValues"], ["jhiTranslate", "sessionChat.paragraph.willStartInAMinute", 1, "time-left"], ["jhiTranslate", "sessionChat.paragraph.timeLeft"], ["jhiTranslate", "sessionChat.paragraph.minutesLeft", 1, "mr-1", "time-left", 3, "translateValues"], [1, "d-none", "d-xl-block", "mr-2"], ["class", "btn btn-primary border-1", "id", "extend-session-btn", 3, "background", "click", 4, "ngIf"], ["id", "extend-session-btn", 1, "btn", "btn-primary", "border-1", 3, "click"], ["jhiTranslate", "sessionChat.button.extendSession"], [1, "btn", "btn-secondary", "border-1", 3, "disabled", "click"], ["jhiTranslate", "sessionChat.button.end"], [1, "d-none", "d-xl-block", "ml-2", "mr-2", "video-icon-div"], [3, "session", "coachDetails", 4, "ngIf"], [3, "session", "coachDetails"], [1, "px-3", "py-2", 2, "background-color", "#F8F7F2", "position", "absolute", "width", "100%", "z-index", "200"], [3, "session", "videoCallIsInProgress"], ["class", "olha-theme", 4, "ngIf"], [1, "olha-theme"], [1, "d-flex", "justify-content-end"], ["icon", "times-circle", 1, "mt-3", "mr-3", 2, "cursor", "pointer", 3, "click"], [1, "modal-body", "text-center"], ["jhiTranslate", "sessionChat.header.confirm"], ["jhiTranslate", "sessionChat.paragraph.end"], [1, "d-flex", "justify-content-center", "mt-4"], ["type", "button", "jhiTranslate", "sessionChat.button.end", 1, "btn", "btn-primary", "m-2", 3, "click"], ["type", "button", "jhiTranslate", "sessionChat.button.close", 1, "btn", "btn-secondary", "m-2", 3, "click"]], template: function SessionControlComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "button", 3);
        i0.ɵɵlistener("click", function SessionControlComponent_Template_button_click_3_listener() { return ctx.openScriptComponent(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(4, "svg", 4);
        i0.ɵɵelement(5, "use", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelement(6, "span", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(7, "div", 7);
        i0.ɵɵelementStart(8, "div", 8);
        i0.ɵɵtemplate(9, SessionControlComponent_div_9_Template, 2, 3, "div", 9);
        i0.ɵɵtemplate(10, SessionControlComponent_div_10_Template, 4, 3, "div", 9);
        i0.ɵɵtemplate(11, SessionControlComponent_div_11_Template, 4, 3, "div", 9);
        i0.ɵɵtemplate(12, SessionControlComponent_div_12_Template, 2, 1, "div", 10);
        i0.ɵɵtemplate(13, SessionControlComponent_div_13_Template, 3, 1, "div", 10);
        i0.ɵɵtemplate(14, SessionControlComponent_div_14_Template, 2, 1, "div", 11);
        i0.ɵɵelementStart(15, "div", 12);
        i0.ɵɵelementStart(16, "session-control-dropdown", 13);
        i0.ɵɵlistener("resourceSelected", function SessionControlComponent_Template_session_control_dropdown_resourceSelected_16_listener($event) { return ctx.onResourceSelected($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(17, SessionControlComponent_div_17_Template, 2, 3, "div", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(18, SessionControlComponent_ng_template_18_Template, 1, 1, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngIf", ctx.session.statusOfSession === "ENDED");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.session.minutesLeftToSessionStart > 10);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.session.statusOfSession !== "ENDED" && ctx.session.minutesLeftToSessionStart <= 10);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.session.started);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.session.started);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.coachDetails == null ? null : ctx.coachDetails.videoChatEnabled) && (ctx.session == null ? null : ctx.session.type) === "video");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("session", ctx.session);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.coachDetails == null ? null : ctx.coachDetails.videoChatEnabled) && (ctx.session == null ? null : ctx.session.type) === "video");
    } }, directives: [i10.JhiTranslateDirective, i11.NgIf, i12.SessionControlDropdownComponent, i13.VideoCallDropdownComponent, i14.InProgressVideoCallIndicatorComponent, i15.FaIconComponent], styles: [".session-control[_ngcontent-%COMP%]{height:60px;width:100%;border-radius:0}.script-div[_ngcontent-%COMP%]:hover   .open-book-icon[_ngcontent-%COMP%]{filter:invert(19%) sepia(80%) saturate(460%) hue-rotate(115deg) brightness(46%) contrast(93%)}.open-book-icon[_ngcontent-%COMP%]{height:14px;width:16px;margin-right:8px}.video-icon-div[_ngcontent-%COMP%]:hover   .video-icon[_ngcontent-%COMP%]{filter:invert(19%) sepia(80%) saturate(460%) hue-rotate(115deg) brightness(46%) contrast(93%)}.video-icon-button[_ngcontent-%COMP%]{height:42px !important;width:42px !important;min-width:42px !important;border-radius:15px}.video-icon[_ngcontent-%COMP%]{height:10px;width:14px}.time-left[_ngcontent-%COMP%]{font-weight:600;color:#44a38b}[_nghost-%COMP%]  .video-icon-tool-tip{color:#fff !important;background:#44a38b !important;border:1px solid #44a38b !important;overflow:visible !important}[_nghost-%COMP%]  .video-icon-tool-tip:before{content:\"\";position:absolute;bottom:-11px;right:calc(50% - 10px);border-top:10px solid #44a38b;border-left:10px solid transparent;border-right:10px solid transparent;z-index:10000}@media(min-width: 1200px){.session-control[_ngcontent-%COMP%]{height:60px;width:100%;border-radius:20px 20px 0 0}}"] });
